import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=f81f5c3c&"
import script from "./Promotions.vue?vue&type=script&lang=ts&"
export * from "./Promotions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports